module.exports = __webpack_public_path__ + "static/media/12-phones.ce6c8b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/emptyState/12-phones.png
// module id = 26
// module chunks = 0